import { css } from '@linaria/core'
import CheckIcon from '#icons/check-16.svg'
import { style } from '#styles/index'

export const partPeriodInputClass = css`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 4px 8px;
  border: 1px solid ${style.themeColors.lineInput};
  min-height: 30px;
  font-size: inherit;

  color: ${style.themeColors.textDefault};
  background-color: ${style.themeColors.backgroundDefault};
  outline: 2px solid transparent;
  transition: 0.25s ease border-color, 0.25s ease outline-color, 0.25s ease color;
  outline-offset: -2px;

  &._disabled {
    pointer-events: none;
    background-color: ${style.themeColors.backgroundBoxed};
    border-color: ${style.themeColors.textDeselected};
    
    > ._icon {
      background-color: ${style.themeColors.textDeselected};
    }
  }
  
  &:hover {
    border-color: ${style.themeColors.lineInputHover}
  }

  &:focus {
    outline-color: ${style.themeColors.lineFocus};
    border-color: ${style.themeColors.lineFocus};
  }
  
  > ._period {
    font-variant: tabular-nums;
  }
  
  > ._icon {
    background-color: ${style.themeColors.textDimmed};
  }
`

export const checkboxClass = css`
  cursor: pointer;
  flex-shrink: 0;
  appearance: none;
  display: inline-block;
  position: relative;
  margin: 0;
  border: 1px solid ${style.themeColors.textDimmed};
  background: ${style.themeColors.backgroundDefault};
  transition: all 0.5s ease;
  width: 20px;
  height: 20px;

  &:hover,
  &:focus-within {
    border: 1px solid ${style.themeColors.lineImportant};
    transition: border 0.5s ease;
  }

  &:checked {
    border: 1px solid ${style.themeColors.lineImportant};
    background: ${style.themeColors.backgroundAccent};
    transition: all 0.5s ease;

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 1px;
      width: 16px;
      height: 16px;
      background: ${style.themeColors.backgroundDefault};
      mask-image: url(${CheckIcon});
      mask-size: cover;
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  ._select-interactive:hover & {
    border: 1px solid ${style.themeColors.lineImportant};

    &:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 1px;
      width: 16px;
      height: 16px;
      background: ${style.themeColors.lineImportant};
      mask-image: url(${CheckIcon});
      mask-size: cover;
    }
  }
`
